// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__18fsS","emails":"CreateEditClinics_emails__2c51y","emailTagLabel":"CreateEditClinics_emailTagLabel__3gIrr"};